const DEFAULT_COMMON_COLORS = [
  '#000000',
  '#222222',
  '#464646',
  '#6D6D6D',
  '#909090',
  '#B1B1B1',
  '#D5D5D5',
  '#E7E7E7',
  '#FFFFFF',
];


export const getThemeEditorUrl = (themeUuid)=>
  `/theme-editor/${themeUuid}`;

export const structureThemeRestData = (themeServerData)=> {
  if (!themeServerData) {
    return { stylePresets: [] };
  }
  
  const { id, uuid, ...themeData } = themeServerData;

  return {
    id,
    uuid,
    customFooterHtml: themeData.custom_footer_html,
    useFixedNavLinks: themeData.fixed_nav_links,
    stylePresets: themeData.page_style_presets.style_presets,
    canShowActionIcons: themeData.can_show_action_icons,
    stylesheetVersion: themeData.stylesheet_version,
    mostCommonFontColors: themeData.most_font_common_colors || DEFAULT_COMMON_COLORS,
    mostCommonBackgroundColors: themeData.most_background_common_colors || DEFAULT_COMMON_COLORS
  };
};
